import React from 'react'
import { gifs } from '../../assets/gifs'

export const LoadingGeneral = () => {
    return (
        <div className="w-screen h-screen bg-1B1464 flex justify-center items-center flex-col">
            <img src={gifs.inmersys_rotate} className="w-36 animate-spin" alt="" />
            <p className="text-2xl text-white font-semibold pt-4 tracking-widest">YOU ARE IN</p>
        </div>
    )
}

export default LoadingGeneral
